import nprLogo   from "./images/npr.svg";
import tnytLogo   from "./images/tnyt.svg";
import bulletLogo from "./images/bulletproof.svg";
import todayLogo from "./images/today.svg";
import abcLogo from "./images/abc.svg";
import goopLogo from "./images/goop.svg";
import timeLogo from "./images/time.svg";
import theviewLogo from "./images/theview.svg";
import oprahLogo from "./images/oprah.svg";
import gmaLogo from "./images/gma.svg";

export default [
  nprLogo,
  tnytLogo,
  bulletLogo,
  todayLogo,
  abcLogo,
  goopLogo,
  timeLogo,
  theviewLogo,
  oprahLogo,
  gmaLogo
];